export default __webpack_public_path__ + "static/media/eleImg_pwd_2_1.7faf7f3e.png";